<app-navbar></app-navbar>



<app-products *ngIf="currentScreen=='products'"></app-products>
<app-orders *ngIf="currentScreen=='orders'"></app-orders>

<app-input-product *ngIf="currentScreen=='inputProduct'"></app-input-product>
<app-edit-product *ngIf="currentScreen=='editProduct'"></app-edit-product>
<app-input-order *ngIf="currentScreen=='inputOrder'"></app-input-order>
<app-edit-order *ngIf="currentScreen=='editOrder'"></app-edit-order>
<app-process-order *ngIf="currentScreen=='processOrder'"></app-process-order>
<app-change-password *ngIf="currentScreen=='changePassword'"></app-change-password>
